module.exports = __webpack_public_path__ + "static/media/mentoring-project.79d0ce81.svg";